import React, { PureComponent } from 'react'
import { AppBar, Tabs, Tab } from '@mui/material'
import { withStyles } from '@mui/styles'
import { connect } from 'react-redux'
import { getIn, is } from 'utils'
import memoize from 'memoize-one'
import { getFormSelector, filterHidden, trimmedCameled } from '../utils'

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps
  const formState = getFormSelector(form)(state)
  const masterOptions = getIn(formState, 'masterOptions')
  const tabComponents = getIn(masterOptions, 'tabComponents')

  const selectedTab = getIn(masterOptions, 'selectedSecondaryTab')
  const selectedPrimaryTab = getIn(masterOptions, 'selectedPrimaryTab')
  const tabMap = getIn(masterOptions, 'secondaryTabMap')
  let tabs = getIn(tabMap, selectedPrimaryTab)
  tabs = tabs && tabs.toJS ? tabs.toJS() : []

  tabs = tabs.reduce((acc, tab) => {
    let t = getIn(
      tabComponents,
      `${trimmedCameled(selectedPrimaryTab)}-${trimmedCameled(tab)}`
    )
    t = t && t.toJS ? t.toJS() : t
    const notHidden = filterHidden(formState)(t)
    if (notHidden) {
      
      const newTab = {
        name: tab
      }
      if (Object.hasOwnProperty.call(t, 'isDisabled')) {
        if (is.bool(t.isDisabled)) {
          newTab.disabled = t.isDisabled
        }
        if (is.fn(t.isDisabled)) {
          newTab.disabled = t.isDisabled(formState.toJS())
        }
      } else {
        newTab.disabled = false
      }
      acc = acc.concat(newTab)
    }

    return acc
  }, [])

  return {
    selectedPrimaryTab,
    tabs,
    value: selectedTab
  }
}

const tabStyles = {
  ddiSecondaryTab: {
    fontSize: '0.8em',
    height: 30,
    minHeight: 30,
    textTransform: 'none'
  }
}
const styles = {
  tabStyles: { height: 30, minHeight: 30 },
  appBarStyles: {

    background: '#c1d5e5',
    boxShadow: 'none',
    height: 30,
    minHeight: 30,
    marginTop: 5
    
  }
}

class SecondaryTabs extends PureComponent {
  onChange = (event, value) => {
    if (value) {
      this.props.changeFormTab(this.props.selectedPrimaryTab, value)
    }
  }
  
  tabs = memoize(tabs =>
    tabs.map(tab => (
      <Tab
        value={trimmedCameled(tab.name)}
        label={tab.name}
        key={tab.name}
        className={this.props.classes.ddiSecondaryTab}
        disabled={tab.disabled}
      />
    ))
  )
  render() {
    const { tabs, value } = this.props
    return (
      tabs.length ? (
        <AppBar
          position="static"
          color="default"
          style={styles.appBarStyles}
        >
          <Tabs
            scrollButtons="on"
            variant="scrollable"
            value={value}
            onChange={this.onChange}
            style={styles.tabStyles}
          >
            {this.tabs(tabs)}
          </Tabs>
        </AppBar>
      ) : (
        <div style={{ height: 0 }} />
      )
    )
  }
}
export default connect(mapStateToProps)(withStyles(tabStyles)(SecondaryTabs))
